@if (queryItem.isGraph) {
  <div class="graph-host">
    @if (!allowedCharts.includes(graphConfig?.chartType)) {
      <div style="text-align: center; padding-top: 20px">
        <mat-icon>bar_chart</mat-icon>
        <h4 i18n="@@invalidChartType">
          The configured chart type is not valid
        </h4>
        <h4>{{ graphConfig?.chartType }}</h4>
      </div>
    }
    @if (allowedCharts.includes(graphConfig?.chartType)) {
      <div
        class="graph-container"
        #graphContainer
        [style.min-height.px]="height || minGraphHeight"
      >
        @if (graphConfig?.chartType === 'bar-horizontal') {
          <ngx-charts-bar-horizontal
            [view]="chartView"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            [schemeType]="schemeType"
            [results]="queryItem.graphData"
            [animations]="false"
            [gradient]="graphConfig.gradient"
            [xAxis]="graphConfig.showXAxis"
            [yAxis]="graphConfig.showYAxis"
            [legend]="graphConfig.showLegend"
            [legendPosition]="graphConfig.legendPosition"
            [showXAxisLabel]="graphConfig.showXAxisLabel"
            [showYAxisLabel]="graphConfig.showYAxisLabel"
            [xAxisLabel]="graphConfig.xAxisLabel"
            [yAxisLabel]="graphConfig.yAxisLabel"
            [tooltipDisabled]="graphConfig.tooltipDisabled"
            [showGridLines]="graphConfig.showGridLines"
            [barPadding]="graphConfig.barPadding"
            [roundDomains]="graphConfig.roundDomains"
            [roundEdges]="graphConfig.roundEdges"
            [noBarWhenZero]="graphConfig.noBarWhenZero"
            [showDataLabel]="graphConfig.showDataLabel"
            [trimXAxisTicks]="graphConfig.trimXAxisTicks"
            [trimYAxisTicks]="graphConfig.trimYAxisTicks"
            [rotateXAxisTicks]="graphConfig.rotateXAxisTicks"
            [maxXAxisTickLength]="graphConfig.maxXAxisTickLength"
            [maxYAxisTickLength]="graphConfig.maxYAxisTickLength"
            [customColors]="graphConfig.customColors"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-bar-horizontal>
        }
        @if (graphConfig?.chartType === 'bar-vertical') {
          <ngx-charts-bar-vertical
            [view]="chartView"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            [schemeType]="schemeType"
            [results]="queryItem.graphData"
            [animations]="false"
            [gradient]="graphConfig.gradient"
            [xAxis]="graphConfig.showXAxis"
            [yAxis]="graphConfig.showYAxis"
            [legend]="graphConfig.showLegend"
            [showXAxisLabel]="graphConfig.showXAxisLabel"
            [showYAxisLabel]="graphConfig.showYAxisLabel"
            [xAxisLabel]="graphConfig.xAxisLabel"
            [yAxisLabel]="graphConfig.yAxisLabel"
            [tooltipDisabled]="graphConfig.tooltipDisabled"
            [showGridLines]="graphConfig.showGridLines"
            [barPadding]="graphConfig.barPadding"
            [roundDomains]="graphConfig.roundDomains"
            [roundEdges]="graphConfig.roundEdges"
            [noBarWhenZero]="graphConfig.noBarWhenZero"
            [showDataLabel]="graphConfig.showDataLabel"
            [trimXAxisTicks]="graphConfig.trimXAxisTicks"
            [trimYAxisTicks]="graphConfig.trimYAxisTicks"
            [rotateXAxisTicks]="graphConfig.rotateXAxisTicks"
            [maxXAxisTickLength]="graphConfig.maxXAxisTickLength"
            [maxYAxisTickLength]="graphConfig.maxYAxisTickLength"
            [yScaleMax]="graphConfig.yScaleMax"
            [customColors]="graphConfig.customColors"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-bar-vertical>
        }
        @if (graphConfig?.chartType === 'pie-chart') {
          <ngx-charts-pie-chart
            [view]="chartView"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            [schemeType]="schemeType"
            [results]="queryItem.graphData"
            [animations]="false"
            [legend]="graphConfig.showLegend"
            [legendTitle]="graphConfig.legendTitle"
            [legendPosition]="graphConfig.legendPosition"
            [labels]="graphConfig.showLabels"
            [doughnut]="graphConfig.doughnut"
            [arcWidth]="graphConfig.arcWidth"
            [gradient]="graphConfig.gradient"
            [tooltipDisabled]="graphConfig.tooltipDisabled"
            [tooltipText]="pieTooltipText"
            [customColors]="graphConfig.customColors"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-pie-chart>
        }
        @if (graphConfig?.chartType === 'advanced-pie-chart') {
          <ngx-charts-advanced-pie-chart
            [view]="chartView"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            [schemeType]="schemeType"
            [results]="queryItem.graphData"
            [animations]="false"
            [valueFormatting]="graphConfig.valueFormatting"
            [gradient]="graphConfig.gradient"
            [tooltipDisabled]="graphConfig.tooltipDisabled"
            [tooltipText]="pieTooltipText"
            [customColors]="graphConfig.customColors"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-advanced-pie-chart>
        }
        @if (graphConfig?.chartType === 'pie-grid') {
          <ngx-charts-pie-grid
            [results]="queryItem.graphData"
            [animations]="false"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            [view]="pieGridView"
            [customColors]="graphConfig.customColors"
            [tooltipDisabled]="graphConfig.tooltipDisabled"
            [designatedTotal]="graphConfig.designatedTotal"
            [minWidth]="graphConfig.minWidth"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-pie-grid>
        }
        @if (graphConfig?.chartType === 'tree-map') {
          <ngx-charts-tree-map
            [view]="chartView"
            [results]="queryItem.graphData"
            [animations]="false"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            [tooltipDisabled]="graphConfig.tooltipDisabled"
            [gradient]="graphConfig.gradient"
            [customColors]="graphConfig.customColors"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-tree-map>
        }
        @if (graphConfig?.chartType === 'number-card') {
          <ngx-charts-number-card
            [results]="queryItem.graphData"
            [animations]="false"
            [scheme]="setColorScheme(graphConfig.colorScheme)"
            cardColor="#232837"
            emptyColor="#1e222e"
            [view]="numberCardView"
            [customColors]="graphConfig.customColors"
            (select)="onGraphClick($event)"
          >
          </ngx-charts-number-card>
        }
      </div>
    }
  </div>
}
